<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <b-form class="p-2" @submit="onSubmit" :method="'POST'" :action="route">
          <input type="hidden" name="_token" :value="csrf" />
          <input type="hidden" name="_method" :value="method" />

          <input type="hidden" :value="form.name" name="name" />
          <input type="hidden" :value="form.permissions" name="permissions" />
          <input type="hidden" :value="form.programIds" name="programIds" />

          <b-alert :show="checkPermissions()" variant="warning">
            <em class="fa fa-info-circle mr-2"></em>
            {{ $t("commons.read_only") }}
          </b-alert>

          <div class="row" v-if="!checkPermissions()">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <b-form-group
                id="fieldset-enter-name"
                label-for="name"
                label-size="lg"
                label-class="font-weight-bold pb-0"
                class="required"
              >
                <template slot="label">
                  <span v-text="$t('roles.name')" />
                </template>
                <b-form-input
                  id="name"
                  name="name"
                  v-model.trim="form.name"
                  :placeholder="$t('roles.enter_name')"
                  maxlength="200"
                />
                <div v-if="hasError('name')">
                  <div
                    class="alert alert-danger mt-1"
                    v-if="show_errors"
                    v-text="$t('commons.required_field_error')"
                  ></div>
                </div>
              </b-form-group>

              <div>
                <div class="btn-group text-left align-items-center mb-4 mt-2">
                  <div class="mr-3">
                    <h5><b>Programs</b></h5>
                  </div>
                  <b-form inline>
                    <div class="flex-fill mr-2">
                      <b-overlay :show="fetching_instances" opacity="0.6">
                        <template #overlay>
                          <div class="d-flex align-items-center">
                            <b-spinner
                              small
                              type="grow"
                              variant="secondary"
                            ></b-spinner>
                            <b-spinner type="grow" variant="dark"></b-spinner>
                            <b-spinner
                              small
                              type="grow"
                              variant="secondary"
                            ></b-spinner>
                            <!-- We add an SR only text for screen readers -->
                            <span class="sr-only">Please wait...</span>
                          </div>
                        </template>
                        <b-input-group
                          :aria-hidden="fetching_instances ? 'true' : null"
                        >
                          <vue-multiselect
                            name="programs"
                            v-model="selectedPrograms"
                            :options="myInstances"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :placeholder="$t('instances.select_programs')"
                            label="name"
                            track-by="id"
                            :preselect-first="true"
                            @input="onSelect"
                            style="
                              line-height: 1.4;
                              width: max-content;
                              min-width: 350px;
                            "
                          >
                            <template
                              slot="selection"
                              slot-scope="{ values, isOpen }"
                              ><span
                                class="multiselect__single"
                                v-if="values.length"
                                v-show="!isOpen"
                                ><b>{{
                                  selectedPrograms.length ==
                                  instances.length - 1
                                    ? "All"
                                    : ""
                                }}</b>
                                ({{ values.length }} programs selected)
                                <span
                                  class="multi-select-remove-icon"
                                  @mousedown.prevent.stop="clearAll()"
                                  >❌</span
                                >
                              </span>
                            </template>
                          </vue-multiselect>
                          <b-button
                            class="ml-3 btn-secondary"
                            v-text="$t('instances.clear_programs')"
                            :disabled="selectedPrograms.length === 0"
                            @click="clearAll()"
                          />
                        </b-input-group>
                      </b-overlay>
                    </div>
                  </b-form>
                </div>
              </div>

              <h5><b>Permissions</b></h5>
            </div>

            <div class="container mt-1">
              <div class="row row-cols-4">
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Users</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isUsersAll"
                      @click="checkAllUsers()"
                      id="users"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('user-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="users_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Roles</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isRolesAll"
                      @click="checkAllRoles()"
                      id="roles"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('role-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="roles_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Programs</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isInstancesAll"
                      @click="checkAllInstances()"
                      id="instances"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('instance-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="instances_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Pharma Ops</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isPharmaopsAll"
                      @click="checkAllPharmaops()"
                      id="pharmaops"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('pharmaops-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="pharmaops_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Auths</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isAuthsAll"
                      @click="checkAllAuths()"
                      id="auths"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('oauth-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="auths_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Message Templates</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isMessageTemplatesAll"
                      @click="checkAllMessageTemplates()"
                      id="message_templates"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('message-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="message_templates_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Actions</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isActionsAll"
                      @click="checkAllActions()"
                      id="actions"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('action-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="actions_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Persons</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isPersonsAll"
                      @click="checkAllPersons()"
                      id="persons"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('person-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="persons_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Campaign Scheduler</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isSchedulerAll"
                      @click="checkAllScheduler()"
                      id="scheduler"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('scheduler-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="scheduler_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Content Management</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isContentAll"
                      @click="checkAllContent()"
                      id="content"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('content-') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="content_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Single-Program Analytics</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isCampaignAll"
                      @click="checkAllCampaign()"
                      id="content"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('campaign-analytics') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="campaign_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="!disabled_multi_analytics" class="col mb-3">
                  <div class="form-check mb-1">
                    <strong>Multi-Program Analytics</strong>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="active"
                      v-model="isAnalyticsAll"
                      @click="checkAllAnalytics()"
                      id="content"
                    />
                    <label class="form-check-label mb-2">
                      <strong>All</strong></label
                    >
                  </div>
                  <div v-for="(item, index) in permissions" :key="index">
                    <div
                      class="form-check"
                      v-if="item.name.indexOf('analytics-report') !== -1"
                    >
                      <input
                        type="checkbox"
                        v-bind:value="item"
                        v-model="analytics_chks"
                        @change="updateCheckall()"
                      />
                      <label class="form-check-label mb-2" for="eventState">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="!checkPermissions()"
            class="row justify-content-end align-items-end w-100"
          >
            <b-form-group>
              <toggle-button
                v-model="isAllOptionsSelected"
                :labels="{ checked: selectAllPermissions, unchecked:deselectAllPermissions }"
                :width="120"
                :height="35"
                :margin="5"
                @input="updateAttributeValue($event)"
                :font-size="14"
                class="mt-2"
                sync
              />
              <b-button
                type="submit"
                class="mr-2"
                variant="primary"
                v-text="save_or_update"
              ></b-button>
              <b-button
                class="btn btn-danger"
                v-text="$t('buttons.cancel')"
                :href="$routes('roles.index')"
              ></b-button>
            </b-form-group>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import InstancesApi from "../../../apis/InstancesApi";
export default {
  props: {
    permissions: Array,
    rolePermissions: Object | Array,
    role: Object | Array,
  },
  computed: {
    myInstances() {
      return this.instances;
    },
    has_permissions() {
      const permission_groups = [
        this.auths_chks.length,
        this.users_chks.length,
        this.roles_chks.length,
        this.instances_chks.length,
        this.pharmaops_chks.length,
        this.message_templates_chks.length,
        this.actions_chks.length,
        this.persons_chks.length,
        this.scheduler_chks.length,
        this.content_chks.length,
        this.campaign_chks.length,
        this.analytics_chks.length,
      ];

      return Boolean(permission_groups.reduce((a, b) => a + b, 0));
    },
    isAllOptionsSelected() {
        return ( this.isUsersAll
        && this.isRolesAll
        && this.isInstancesAll
        && this.isPharmaopsAll
        && this.isAuthsAll
        && this.isMessageTemplatesAll
        && this.isActionsAll
        && this.isPersonsAll
        && this.isSchedulerAll
        && this.isContentAll
        && this.isCampaignAll
        && this.isAnalyticsAll);
    }
  },
  data() {
    return {
      csrf: null,
      route: null,
      show_errors: false,
      instances: [],
      isUsersAll: false,
      users_chks: [],
      isRolesAll: false,
      roles_chks: [],
      isInstancesAll: false,
      instances_chks: [],
      isPharmaopsAll: false,
      pharmaops_chks: [],
      isAuthsAll: false,
      auths_chks: [],
      isMessageTemplatesAll: false,
      message_templates_chks: [],
      isActionsAll: false,
      actions_chks: [],
      isPersonsAll: false,
      isSchedulerAll: false,
      isContentAll: false,
      isCampaignAll: false,
      isAnalyticsAll: false,
      persons_chks: [],
      scheduler_chks: [],
      content_chks: [],
      campaign_chks: [],
      analytics_chks: [],
      method: "POST",
      save_or_update: this.$t("buttons.save"),
      deselectAllPermissions: this.$t("instances.deselect_all_permissions"),
      selectAllPermissions: this.$t("instances.select_all_permissions"),
      selected: [],
      errors: [],
      form: {
        name: null,
        programIds: [],
        permissions: null,
      },
      fetching_instances: false,
      selectedPrograms: [],
      programs_applied: false,
      disabled_multi_analytics: false,
    };
  },
  created() {
    this.getInstances();
    this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
    this.route = this.$routes("roles.store", {
      role: this.form,
    });
    if (!_.isEmpty(this.oldInput)) {
      this.form.name = this.oldInput.name;
      this.form.permissions = this.oldInput.permissions;
      this.form.programIds = this.oldInput.programIds;
    } else if (this.role) {
      this.method = "PUT";
      this.route = this.$routes("roles.update", {
        role: this.role,
      });
      this.save_or_update = this.$t("buttons.update");

      this.form.name = this.role.name;
      this.form.permissions = JSON.stringify(this.rolePermissions);
      this.form.programIds = JSON.stringify(this.role.programIds);
      this.selectedPrograms = JSON.parse(this.role.programIds);
      this.disabled_multi_analytics = this.selectedPrograms ? this.selectedPrograms.length == 1 : false;
      this.initForm();
    }
  },
  methods: {
    clearAll() {
      this.selectedPrograms = [];
    },
    checkPermissions() {
      let permissions = this.permissions.filter(function (permission) {
        if (permission.name == "role-read") {
          return true;
        }
      });
      return permissions.length ? false : true;
    },
    uncheckAllPermissions() {
        this.auths_chks = [];
        this.users_chks = [] = [];
        this.roles_chks = [];
        this.instances_chks = [];
        this.pharmaops_chks = [];
        this.message_templates_chks = [];
        this.actions_chks = [];
        this.persons_chks = [];
        this.scheduler_chks = [];
        this.content_chks = [];
        this.campaign_chks = [];
        this.analytics_chks = [];

        this.isUsersAll = false;
        this.isRolesAll = false;
        this.isInstancesAll = false;
        this.isPharmaopsAll = false;
        this.isAuthsAll = false;
        this.isMessageTemplatesAll = false;
        this.isActionsAll = false;
        this.isPersonsAll = false;
        this.isSchedulerAll = false;
        this.isContentAll = false;
        this.isCampaignAll = false;
        this.isAnalyticsAll = false;
    },
    checkAllPermissions() {
        this.checkAllUsers(true);
        this.checkAllRoles(true);
        this.checkAllInstances(true);
        this.checkAllPharmaops(true);
        this.checkAllAuths(true);
        this.checkAllMessageTemplates(true);
        this.checkAllActions(true);
        this.checkAllPersons(true);
        this.checkAllScheduler(true);
        this.checkAllContent(true);
        this.checkAllCampaign(true);
        this.checkAllAnalytics(true);
    },
    updateAttributeValue($event){
      ($event)? this.checkAllPermissions() : this.uncheckAllPermissions();
    },
    checkAllUsers(forceCheck = null) {
      this.isUsersAll = (forceCheck===null) ? !this.isUsersAll : forceCheck;
      this.users_chks = [];
      if (this.isUsersAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("user-")) {
            this.users_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllRoles(forceCheck = null) {
      this.isRolesAll = (forceCheck===null) ? !this.isRolesAll : forceCheck;
      this.roles_chks = [];
      if (this.isRolesAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("role-")) {
            this.roles_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllInstances(forceCheck = null) {
      this.isInstancesAll = (forceCheck===null) ? !this.isInstancesAll : forceCheck;
      this.instances_chks = [];
      if (this.isInstancesAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("instance-")) {
            this.instances_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllPharmaops(forceCheck = null) {
      this.isPharmaopsAll = (forceCheck===null) ? !this.isPharmaopsAll : forceCheck;
      this.pharmaops_chks = [];
      if (this.isPharmaopsAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("pharmaops-")) {
            this.pharmaops_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllAuths(forceCheck = null) {
      this.isAuthsAll = (forceCheck===null) ? !this.isAuthsAll : forceCheck;
      this.auths_chks = [];
      if (this.isAuthsAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("oauth-")) {
            this.auths_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllMessageTemplates(forceCheck = null) {
      this.isMessageTemplatesAll = (forceCheck===null) ? !this.isMessageTemplatesAll : forceCheck;
      this.message_templates_chks = [];
      if (this.isMessageTemplatesAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("message-")) {
            this.message_templates_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllActions(forceCheck = null) {
      this.isActionsAll = (forceCheck===null) ? !this.isActionsAll : forceCheck;
      this.actions_chks = [];
      if (this.isActionsAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("action-")) {
            this.actions_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllPersons(forceCheck = null) {
      this.isPersonsAll = (forceCheck===null) ? !this.isPersonsAll : forceCheck;
      this.persons_chks = [];
      if (this.isPersonsAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("person-")) {
            this.persons_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllScheduler(forceCheck = null) {
      this.isSchedulerAll = (forceCheck===null) ? !this.isSchedulerAll : forceCheck;
      this.scheduler_chks = [];
      if (this.isSchedulerAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("scheduler-")) {
            this.scheduler_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllContent(forceCheck = null) {
      this.isContentAll = (forceCheck===null) ? !this.isContentAll : forceCheck;
      this.content_chks = [];
      if (this.isContentAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("content-")) {
            this.content_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllCampaign(forceCheck = null) {
      this.isCampaignAll = (forceCheck===null) ? !this.isCampaignAll : forceCheck;
      this.campaign_chks = [];
      if (this.isCampaignAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("campaign-analytics")) {
            this.campaign_chks.push(this.permissions[key]);
          }
        }
      }
    },
    checkAllAnalytics(forceCheck = null) {
      this.isAnalyticsAll = (forceCheck===null) ? !this.isAnalyticsAll : forceCheck;
      this.analytics_chks = [];
      if (this.isAnalyticsAll) {
        // Check all
        for (var key in this.permissions) {
          if (this.permissions[key].name.includes("analytics-report")) {
            this.analytics_chks.push(this.permissions[key]);
          }
        }
      }
    },
    updateCheckall() {
      this.isUsersAll = this.users_chks.length == 4;
      this.isRolesAll = this.roles_chks.length == 4;
      this.isInstancesAll = this.instances_chks.length == 3;
      this.isPharmaopsAll = this.pharmaops_chks.length == 3;
      this.isAuthsAll = this.auths_chks.length == 4;
      this.isMessageTemplatesAll = this.message_templates_chks.length == 5;
      this.isActionsAll = this.actions_chks.length == 4;
      this.isPersonsAll = this.persons_chks.length == 4;
      this.isSchedulerAll = this.scheduler_chks.length == 4;
      this.isContentAll = this.content_chks.length == 5;
      this.isCampaignAll = this.campaign_chks.length == 1;
      this.isAnalyticsAll = this.analytics_chks.length == 1;
    },
    getRolePermissions() {
      let permissions = [];
      this.persons_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.actions_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.auths_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.pharmaops_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.instances_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.roles_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.users_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.message_templates_chks.forEach((person) => {
        permissions.push(person.id);
      });
      this.scheduler_chks.forEach((scheduler) => {
        permissions.push(scheduler.id);
      });
      this.content_chks.forEach((content) => {
        permissions.push(content.id);
      });
      this.campaign_chks.forEach((campaign) => {
        permissions.push(campaign.id);
      });
      this.analytics_chks.forEach((analytic) => {
        permissions.push(analytic.id);
      });

      return permissions;
    },
    initForm() {
      const role_permissions = Object.keys(this.rolePermissions);
      this.permissions.forEach((permission) => {
        if (role_permissions.includes(permission.id.toString())) {
          if (permission.name.includes("user-")) {
            this.users_chks.push(permission);
          } else if (permission.name.includes("role-")) {
            this.roles_chks.push(permission);
          } else if (permission.name.includes("instance-")) {
            this.instances_chks.push(permission);
          } else if (permission.name.includes("pharmaops-")) {
            this.pharmaops_chks.push(permission);
          } else if (permission.name.includes("oauth-")) {
            this.auths_chks.push(permission);
          } else if (permission.name.includes("message-")) {
            this.message_templates_chks.push(permission);
          } else if (permission.name.includes("action-")) {
            this.actions_chks.push(permission);
          } else if (permission.name.includes("person-")) {
            this.persons_chks.push(permission);
          } else if (permission.name.includes("scheduler-")) {
            this.scheduler_chks.push(permission);
          } else if (permission.name.includes("content-")) {
            this.content_chks.push(permission);
          } else if (permission.name.includes("campaign-analytics")) {
            this.campaign_chks.push(permission);
          } else if (permission.name.includes("analytics-report-")) {
            this.analytics_chks.push(permission);
          }
        }
      });
      this.updateCheckall();
    },
    onSubmit(e) {
      this.show_errors = true;

      if (Object.keys(this.errors).length != 0) {
        this.$toast.error("Error", "There are errors on the form");
        e.preventDefault();
        return;
      }

      this.form.permissions = JSON.stringify(this.getRolePermissions());
      this.form.programIds =  JSON.stringify(this.selectedPrograms);
      this.saving = true;
    },
    hasError(field) {
      if (!this.form[field] || this.form[field].length == 0) {
        this.errors[field] = true;
        return true;
      } else {
        delete this.errors[field];
        return false;
      }
    },
    updateSetup() {
      this.form.brand_name = this.currentUser.brand_name;
      this.form.email = this.currentUser.email;
    },
    getInstances() {
      this.fetching_instances = true;
      InstancesApi.all({
        limit: 10000,
        orderBy: "name",
        returns: "id,name",
      })
        .then((r) => {
          this.fetching_instances = false;
          this.instances = r.result;
          this.instances.unshift({ id: -1, name: "All" });
        })
        .catch((e) => {
          this.fetching_instances = false;
          this.$toast.error(
            "Error",
            this.$t("commons.unable_to_fetch_instances")
          );
        });
    },
    onSelect(e) {
      const allItem = this.selectedPrograms.find((e) => e.id === -1);
      this.disabled_multi_analytics = e.length == 1 && !allItem;
      if (allItem) {
        this.selectedPrograms = this.instances.filter((item) => item.id !== -1);
      }
    },
  },
};
</script>
